var app = angular.module("leonardo");

var ReportsFiltersBase = function (
  $scope,
  $state,
  $controller,
  $timeout,
  ReportService,
  $rootScope
) {

  $controller('FiltersBaseController', { $scope: $scope });

  $scope.filters_name = [
    'reports.my-reports',
    'reports.quick' ,
    'reports.admin-quick',
    'reports.quick.add'
  ].includes($state.current.name) ? 'filters_report' : 'filters';

  $scope.group_options = [];
  if (($scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin())) {
    $scope.group_options.push({ id: 'ungroup', name: 'No group' });
  }
  $scope.group_options.push({ id: 'account', name: 'Account' });
  $scope.group_options.push({ id: 'group', name: 'Property Groups' });
  $scope.group_options.push({ id: 'portfolio', name: 'Portfolio' });
  $scope.group_options.push({ id: 'property', name: 'Property' });

  $scope.filters_base = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'account_reports',
          name: 'Account',
          label: 'Account',
          inline: false,
          type: 'options',
          multiple: true,
          required: ($scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin()),
          placeholder: 'All Accounts',
          condition: $scope.filterService.accounts.length > 1,
          options: $scope.filterService.accounts,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'managed_by_reports',
          name: 'Management Company',
          label: 'Management Company',
          inline: false,
          type: 'options',
          multiple: true,
          required: ($scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin()),
          placeholder: 'All Management Companies',
          condition: $scope.filterService.managers.length > 1,
          options: $scope.filterService.managers,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'account_reports']
        },
        {
          id: 'group_reports',
          name: 'Property Group',
          label: 'Property Group',
          inline: false,
          type: 'options',
          multiple: true,
          required: ($scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin()),
          placeholder: 'All Groups',
          condition: $scope.filterService.groups.length > 1 && !$scope.only_account,
          options: $scope.filterService.groups,
          conflicts: ['property_reports', 'portfolio_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'portfolio_reports',
          name: 'Portfolio',
          label: 'Portfolio',
          inline: false,
          type: 'options',
          multiple: true,
          required: ($scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin()),
          placeholder: 'All Portfolios',
          condition: $scope.filterService.portfolios.length > 1 && !$scope.only_account,
          options: $scope.filterService.portfolios,
          conflicts: ['property_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'property_reports',
          name: 'Property',
          label: 'Property',
          inline: false,
          type: 'property_selector',
          multiple: true,
          required: ($scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin()),
          placeholder: 'All Properties',
          condition: $scope.filterService.properties.length > 1 && !$scope.only_account,
          options: $scope.filterService.properties,
          conflicts: ['portfolio_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        }
      ]
    },
    {
      group: 'due_date',
      name: 'Due Date',
      elements: [
        {
          id: 'from_date',
          name: 'From',
          label: 'From',
          inline: false,
          type: 'date',
          placeholder: 'From',
          condition: true,
          conflicts: [],
          positionVertical: 'bottom',
          endDate: 'to_date'
        },
        {
          id: 'to_date',
          name: 'To',
          label: 'To',
          inline: false,
          type: 'date',
          placeholder: 'To',
          condition: true,
          conflicts: [],
          positionVertical: 'bottom',
          startDate: 'from_date'
        },
        {
          id: 'date_range',
          name: 'Dates Range',
          label: 'Dates Range',
          inline: false,
          type: 'date_range',
          placeholder: 'Dates Range',
          condition: true,
          conflicts: [],
          startDate: 'from_date',
          endDate: 'to_date'
        }
      ]
    },
    {
      group: 'group_results',
      name: 'Group Results',
      elements: [
        {
          id: 'group_by',
          name: 'Group By',
          label: 'Group By',
          inline: false,
          type: 'options',
          multiple: false,
          placeholder: 'Select Group',
          condition: true,
          options: $scope.group_options,
          conflicts: []
        }
      ]
    }
  ];

  $scope.isValid = function(filter_id) {
    var valid = false;
    angular.forEach($scope.filters_options, function(filter) {
      if (filter.id === filter_id) {
        valid = true;
      }
      angular.forEach(filter.elements, function(element) {
        var elementId = element && element.id ? element.id : element;
        if (elementId === filter_id) {
          valid = true;
        }
      });
    });
    return valid;
  };

  $scope.initializeFilters = function () {
    if ($scope.filters_name !== 'filters_report') {
      if ($rootScope.isInIframe) {
        var iframeRaw = null;
        var iframeParsed = null;
        try {
          iframeRaw = window.sessionStorage.getItem('iframe_filter_data');
          if (iframeRaw) {
            window.sessionStorage.removeItem('iframe_filter_data');
          }
          iframeParsed = JSON.parse(iframeRaw);
        } catch (e) {}
        if (iframeParsed) {
          if (iframeParsed.from_date && !$scope.filterService.hasFilter('from_date')) {
            $scope.filterService.setFilter('from_date', iframeParsed.from_date, true);
          }
          if (iframeParsed.to_date && !$scope.filterService.hasFilter('to_date')) {
            $scope.filterService.setFilter('to_date', iframeParsed.to_date, true);
          }
        }
      }

      var filters = $scope.filterService.hasFilter($scope.filters_name) ? $scope.filterService.getFilter($scope.filters_name) : [];

      if (!angular.isArray(filters)) {
        filters = filters.split(',');
      }

      if (!$scope.filterService.hasFilter('from_date') && isNull(ReportService.getQuickReport())) {
        if (!$scope.filterService.hasFilter('date_range')) {
          $scope.filterService.setFilter('from_date', moment().subtract(1, 'months').format('YYYY-MM-DD'), true);
        }
        if (!_.contains(filters,'from_date')) {
          filters.push('from_date');
        }
      }

      if (!$scope.filterService.hasFilter('to_date') && isNull(ReportService.getQuickReport())) {
        if (!$scope.filterService.hasFilter('date_range')) {
          $scope.filterService.setFilter('to_date', moment().format('YYYY-MM-DD'), true);
        }
        if (!_.contains(filters,'to_date')) {
          filters.push('to_date');
        }
      }

      if (!$scope.filterService.hasFilter('date_range') && isNull(ReportService.getQuickReport()) &&
        !_.contains(filters,'date_range')) {
        filters.push('date_range');
      }

      if (!$scope.filterService.hasFilter('group_by') && ($scope.isValid('group_by'))) {
        $scope.filterService.setFilter('group_by', 'property');
        if (!_.contains(filters,'group_by')) {
          filters.push('group_by');
        }
      }

      if($scope.filterService.hasFilter('created_date_range') && $scope.filterService.hasFilter('created_from_date') && $scope.filterService.hasFilter('created_to_date')) {
         $scope.filterService.removeFilter('created_from_date', true);
         $scope.filterService.removeFilter('created_to_date', true);
      }

      $timeout(function() {
        var service_filters = angular.copy($scope.filterService.filters);
        angular.forEach(service_filters, function(value, key) {
          if (!_.contains(['account', 'portfolio', 'property'], key)) {
            if (!$scope.isValid(key)) {
              $scope.filterService.removeFilter(key, true);
            }
            else if (!_.contains(filters, key)) {
              filters.push(key);
            }
          }
        });
        $scope.filterService.setFilter($scope.filters_name, filters);
      }, 0);
    }
  };

  $scope.removeOption = function(key) {
    var array = [];
    angular.forEach($scope.filters_base, function(object) {
      if (object.elements) {
        var element = angular.copy(object);
        element.elements = [];
        angular.forEach(object.elements, function(filter) {
          if (filter && filter.id !== key) {
            element.elements.push(filter);
          }
        });
        if (element.elements.length > 0) {
          array.push(element);
        }
      }
      else if (object && object.id !== key) {
        array.push(object);
      }
    });
    return array;
  };

  $scope.removeFiltersOptions = function(id) {
    if (angular.isArray(id)) {
      angular.forEach(id, function(key) {
        $scope.filters_base = $scope.removeOption(key);
      });
    }
    else {
      $scope.filters_base = $scope.removeOption(id);
    }
    return $scope.filters_base;
  };

  $scope.$on('filter-service:filter-changed', function(event, key, value) {
    if ((key === $scope.filters_name) && ($scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin())) {
      var filters = value ? value : [];

      if (!angular.isArray(filters)) {
        filters = filters.split(',');
      }
      if (_.contains(filters, 'account_reports') && !$scope.filterService.hasFilter('account_reports')) {
        $scope.filterService.setFilter('account_reports', $scope.filterService.accounts.length > 0 ? $scope.filterService.accounts[0].id : null);
      }
      if (_.contains(filters, 'managed_by_reports') && !$scope.filterService.hasFilter('managed_by_reports')) {
        $scope.filterService.setFilter('managed_by_reports', $scope.filterService.managers.length > 0 ? $scope.filterService.managers[0].id : null);
      }
      if (_.contains(filters, 'group_reports') && !$scope.filterService.hasFilter('group_reports')) {
        $scope.filterService.setFilter('group_reports', $scope.filterService.groups.length > 0 ? $scope.filterService.groups[0].id : null);
      }
      if (_.contains(filters, 'portfolio_reports') && !$scope.filterService.hasFilter('portfolio_reports')) {
        $scope.filterService.setFilter('portfolio_reports', $scope.filterService.portfolios.length > 0 ? $scope.filterService.portfolios[0].id : null);
      }
      if (_.contains(filters, 'property_reports') && !$scope.filterService.hasFilter('property_reports')) {
        $scope.filterService.setFilter('property_reports', $scope.filterService.properties.length > 0 ? $scope.filterService.properties[0].id : null);
      }
    }
  });

  $scope.$on('filters-report:initialized', function() {
    $scope.initializeFilters();
  });

};

app.controller('ReportsFiltersBase', [
  '$scope',
  '$state',
  '$controller',
  '$timeout',
  'ReportService',
  '$rootScope',
  ReportsFiltersBase
]);
